import { getCookie, setCookie } from '../utils/storage'
import localeMapping from './locale/translations'
import { source } from './locale/source'

export const SET_I18N = 'i18n/SET_I18N'

export const fetchI18n = () => async dispatch => {
  const _locale = getCookie('lang').toLowerCase() || 'en'
  const currentData = { ...source, ...localeMapping[_locale] }
  const data = {
    locale: _locale,
    data: currentData,
  }
  dispatch({
    type: SET_I18N,
    data,
  })

  window.localStorage.setItem('lang_data', JSON.stringify(data))
}

export const setI18n = locale => (dispatch, getState) => {
  let _locale = locale
  // get locale: from cookie
  if (!_locale) {
    _locale = getCookie('lang').toLowerCase()
  }

  _locale = locale || 'en'

  const { locale: prevLocale } = getState().i18n
  if (prevLocale === _locale) return
  const currentData = { ...source, ...localeMapping[_locale] }
  const data = {
    locale: _locale,
    data: currentData,
  }
  dispatch({
    type: SET_I18N,
    data,
  })
  setCookie('lang', _locale)
  window.localStorage.setItem('lang_data', JSON.stringify(data))

  if (typeof window !== 'undefined' && !window.prerenderReady) {
    setTimeout(() => {
      window.prerenderReady = true
    }, 50)
  }
}

const getLangData = () => {
  const langData = window.localStorage.getItem('lang_data')
  return langData ? JSON.parse(langData) : { locale: '', data: {} }
}

const initialState = getLangData()

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_I18N: {
      return {
        ...state,
        ...action.data,
      }
    }
    default: {
      return state
    }
  }
}
